import React, { useState, useEffect } from "react";
import {
  Container,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Center,
  Spinner,
} from "@chakra-ui/react";
import LabelTab from "../components/tabs/LabelTab";
import MusicianTab from "../components/tabs/MusicianTab";
import AlbumTab from "../components/tabs/AlbumTab";

const Release = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 데이터 로딩 시뮬레이션 (실제로는 API 호출 등)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container maxW="container.xl" py={8}>
      {loading ? (
        <Center py={20}>
          <Spinner size="xl" />
        </Center>
      ) : (
        <Tabs defaultIndex={2}>
          <TabList>
            <Tab
              _focus={{ outline: "none", boxShadow: "none", border: "none" }}
              _active={{ outline: "none", boxShadow: "none", border: "none" }}
              className="no-outline"
            >
              레이블
            </Tab>
            <Tab
              _focus={{ outline: "none", boxShadow: "none", border: "none" }}
              _active={{ outline: "none", boxShadow: "none", border: "none" }}
              className="no-outline"
            >
              뮤지션
            </Tab>
            <Tab
              _focus={{ outline: "none", boxShadow: "none", border: "none" }}
              _active={{ outline: "none", boxShadow: "none", border: "none" }}
              className="no-outline"
            >
              음반
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <LabelTab />
            </TabPanel>
            <TabPanel>
              <MusicianTab />
            </TabPanel>
            <TabPanel>
              <AlbumTab />
            </TabPanel>
          </TabPanels>
        </Tabs>
      )}
      <style>{`
        .no-outline:focus, .no-outline:active {
          outline: none !important;
          box-shadow: none !important;
          border: none !important;
        }
      `}</style>
    </Container>
  );
};

export default Release;
